import ElakayImage from '../../components/images/ElakayImage';
import { useLocation } from "react-router-dom";
import { resolveProductShop, withProductShop } from "../shops/productShop";
import ProductShopChooser from "../shops/ProductShopChooser";
// ShowImage.js (Improved Design & Enhanced)
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { toImageUrl } from "../../config";
import Vote from './commentaire/vote';
import imgProductLakay from '../Layout/imgs/md3.jpg';
import Loader from "../Layout/loader.gif";
import "./showImagesLoading.css";
import imageEmptyelakay from "../Layout/imgs/imageEmptyelakay.jpeg";
import Modal from 'react-bootstrap/Modal';
import ModalProdView from "../pageInside/modalProductView";
import ShopUserView from "../pages/lakayUser/ShopUser";
import { commentProduct } from "../auth/apiProduct";
import { UserVoteCount } from "./commentaire/userVoteCount";
import { GrView } from "react-icons/gr";
import { FaStore } from "react-icons/fa6";
import { buildProductEditPath } from "../../utils/publicIdentifier";

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["showImage"]?.[key] || fallback;

// import { getParamsAndQueriesCleaned } from '../auth/elakay-utils';


export const getParamsAndQueriesCleaned = (url, baseSegment = "img") => {
  try {
    // Vérifie si l'URL est valide
    if (!url || typeof url !== "string" || !url.startsWith("http")) {
      return { params: {}, query: {}, error: true };
    }

    const parsedUrl = new URL(url);

    // 🔹 Nettoyage des query parameters
    const query = {};
    for (const [key, value] of parsedUrl.searchParams.entries()) {
      const decoded = decodeURIComponent(value);
      const clean = decoded.replace(/["'\s]/g, ""); // supprime guillemets + espaces
      query[key] = clean;
    }

    // 🔹 Extraction des params après baseSegment
    const pathSegments = parsedUrl.pathname.split("/").filter(Boolean);
    const baseIndex = pathSegments.indexOf(baseSegment);

    const params = {};
    if (baseIndex !== -1) {
      pathSegments.slice(baseIndex + 1).forEach((segment, index) => {
        const cleanSegment = segment.replace(/\s/g, "");
        params[`param${index + 1}`] = cleanSegment;
      });
    }

    return { params, query, error: false };
  } catch (err) {
    console.warn("⚠️ Erreur lors de l’analyse de l’URL:", err.message);
    // Retourne vide si l’URL est invalide
    return { params: {}, query: {}, error: true };
  }
};
const ShowImage = ({
  infoSource,
  item,
  filterProduct,
  nbrUserVote,
  productId,
  categoryId,
  isIncompleteProduct = false,
  token,
  showB = true,
  showShopV = true,
  showButtonUser = false,
  urlImg,
  rating,
  filterColor,
  owner_id,
  urlFilter,
  edit = false,
  currentShopId = null
}) => {
  __setElakayInfoSource(infoSource);
  const [galeries, setImagSize] = useState([]);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [selectedShopId, setSelectedShopId] = useState(null);
  const resolvedShop = resolveProductShop({ product: item, selectedShopId, currentShopId: currentShopId || new URLSearchParams(location.search).get("shop") });
  const [getShowShop, setShowShop] = useState(false);
  const [filters, setFilters] = useState([]);
  const [filter, setFilter] = useState([]);
  const [values, setValues] = useState({});
  const [showListe, setShowListe] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [commentsPro, setCommentsPro] = useState([]);
  const [sizeComments, SetSizeComments] = useState(0);
  const [limit] = useState(10);
  const [skip, setSkip] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [getUserVote, setUserVote] = useState([]);
  const [isHovered, setIsHovered] = useState(false);
  const [myFilters] = useState({
    filters: { "categoriesID.gategoriesLink": [] }
  });

  const { getButtonTitle } = infoSource;

  useEffect(() => {
    setImagSize(item?.galeries || []);
    setFilter(filterProduct || []);
    setValues(item || []);
  }, [item, filterProduct]);

  // useEffect(() => {
  //   setIsLoading(true);
  // }, [urlImg]);

  const ButtonAddComments = (show = true) => {
    show && setShowComments(false);
    commentProduct(productId, skip, limit).then(data => {
      if (!data) {
      } else {
        setCommentsPro(data.commentsPagination);
        SetSizeComments(data.commentsCount?.[0] && data.commentsCount[0].totalComments);
        setUserVote(data.userVote?.[0] && data.userVote[0].vote);
      }
    });
  };

  const nameImg = typeof item?.name === 'string' ? item.name : (item?.name?.[0] || 'Elakay product');
  const showVote = rating > 0;

  const VoteDisplay = () => (
    showVote && (
      <div className="vote-overlay">
        <div className="vote-content">
          <Vote rating={parseFloat(rating)} />
          <span className="vote-count">({UserVoteCount(nbrUserVote)})</span>
        </div>
      </div>
    )
  );

  const ActionButton = ({ icon: Icon, onClick, position, title, className = "" }) => (
    <button
      className={`image-action-btn ${className} ${position}`}
      onClick={onClick}
      data-toggle="tooltip"
      data-placement="top"
      title={title}
    >
      <Icon />
    </button>
  );

  const ShopViewModal = () => (
    <>
      <style>
        {`
          .tracking-modal {
            width: auto;
          }

          .tracking-modal-content {
            background-color: #fff;
            padding: 0;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
            position: relative;
          }

          .tracking-close-btn {
            position: absolute;
            top: 16px;
            right: 16px;
            z-index: 10;
            background: rgba(255, 255, 255, 0.95);
            backdrop-filter: blur(10px);
            border: none;
            font-size: 1.75rem;
            line-height: 1;
            color: #333;
            border-radius: 50%;
            width: 42px;
            height: 42px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            cursor: pointer;
            transition: all 0.3s ease;
          }

          .tracking-close-btn:hover {
            background-color: #f5f5f5;
            transform: rotate(90deg);
            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
          }

          .tracking-iframe {
            width: 100%;
            height: 95vh;
            border: none;
            display: block;
          }

          @media (max-width: 768px) {
            .tracking-iframe {
              height: 99vh;
            }
          }
        `}
      </style>
      <Modal
        size="xl"
        show={getShowShop}
        onHide={() => setShowShop(false)}
        centered
        dialogClassName="tracking-modal"
        contentClassName="tracking-modal-content"
        aria-labelledby="shop-modal"
      >
        <button
          className="tracking-close-btn"
          onClick={() => setShowShop(false)}
          aria-label={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).showImage.t001}
        >
          ×
        </button>
        <ProductShopChooser product={item} shop={resolvedShop} onChange={setSelectedShopId} />
        <ShopUserView
          shopId={resolvedShop?._id || null}
          key={String(resolvedShop?._id || owner_id)}
          setLoading={setLoading}
          infoSource={infoSource}
          showFilter={false}
          userID={owner_id}
          myFilters={myFilters}
        />
      </Modal>
    </>
  );

  const LoadingImage = () => {
    const parsed = getParamsAndQueriesCleaned(urlImg);
    const colorBackground = parsed.error || !parsed.query?.bgc ? "#FFFFFF" : parsed.query.bgc;

    return (
      <div 
      className="image-container"
      >
        {isLoading && (
          <div className="loading-overlay">
            <span className="eli-placeholder" aria-hidden="true" style={{ backgroundColor: "#f1f3f5" }} />
            <div className="loading-text">
              <span className="lading-elakay"></span>{__elakayText("t002", "Loading...")}</div>
              
          </div>
        )}

        <ElakayImage
          preset="product-card"
          fallback={imageEmptyelakay}
          className="product-image"
          src={toImageUrl(urlImg)}
          loading="lazy"
          decoding="async"
          onLoad={() => setIsLoading(false)}
          onError={(event) => {
            event.target.src = imageEmptyelakay;
            setIsLoading(false);
            event.onerror = null;
          }}
          alt={nameImg}
          style={{
            backgroundColor: colorBackground,
            // `display: none` gives the <img> no layout box, and a box-less
            // element never gets observed by loading="lazy"'s intersection
            // check -> its fetch (and thus onLoad) never fires, so it stays
            // stuck behind the loading overlay forever for any card not
            // already in the viewport. Fade with opacity instead (same
            // pattern as showImagesLoading.jsx's .eli-img) so the image
            // keeps its box and can actually load.
            opacity: isLoading ? 0 : 1,
          }}
        />
      </div>
    );
  };

  let urlFil = urlFilter ? urlFilter : '';
  // isIncompleteProduct ne doit renvoyer vers la gestion du listing
  // (/myshop?sel=true) que pour le vendeur propriétaire (showButtonUser) --
  // sinon un acheteur qui tombe sur un produit dropshipping pas encore
  // entièrement configuré (categoriesID/filterProduct vides après import CJ,
  // cf. cjProductSyncService.importCJProductToElakay) se retrouve envoyé sur
  // la page de gestion du vendeur au lieu de ProductPreview.
  let urlImage = edit
    ? buildProductEditPath({}, productId)
    : (isIncompleteProduct && showButtonUser)
    ? `/myshop?sel=true&ip=${productId}`
    : withProductShop(`/product/preview/${productId}${urlFil}`, resolvedShop);

  return (
    <div
      className={`show-image-wrapper ${isHovered ? 'hovered' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Link to={urlImage} 
      className="image-link"
      >
        {LoadingImage()}
        <VoteDisplay />
      </Link>

      {showB && (
        <ActionButton
          icon={GrView}
          onClick={() => {
            setShowListe(true);
            ButtonAddComments();
          }}
          position="left"
          title={getButtonTitle("viewProduct")}
          className="view-btn"
        />
      )}

      {showShopV && (
        <ActionButton
          icon={FaStore}
          onClick={() => setShowShop(true)}
          position="right"
          title={getButtonTitle("viewShop")}
          className="shop-btn"
        />
      )}

      {ShopViewModal()}

      <ModalProdView
        shopId={resolvedShop?._id}
        infoSource={infoSource}
        skip={skip}
        limit={limit}
        voteA={getUserVote}
        comments={commentsPro}
        productId={productId}
        token={token}
        setCommentsPro={setCommentsPro}
        SetSizeComments={SetSizeComments}
        setUserVote={setUserVote}
        setShowComments={setShowComments}
        commentProduct={commentProduct}
        ButtonAddComments={ButtonAddComments}
        showComments={showComments}
        showButtonUser={showButtonUser}
        setShowListe={setShowListe}
        image={urlImg}
        showListe={showListe}
        productV={{ galeries, filter, values, urlImg, filterColor }}
      />
    </div>
  );
};

export default ShowImage;
